import { render, staticRenderFns } from "./BankAccountSelector.vue?vue&type=template&id=a1030fcc&scoped=true&"
import script from "./BankAccountSelector.vue?vue&type=script&lang=js&"
export * from "./BankAccountSelector.vue?vue&type=script&lang=js&"
import style0 from "./BankAccountSelector.vue?vue&type=style&index=0&id=a1030fcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1030fcc",
  null
  
)

export default component.exports